<script setup>
import { ref, reactive, unref } from "vue";
import { postRequest } from "@/utils/request.js";
import { message } from "ant-design-vue";

const title = ref("重置密码");
const confirmLoading = ref(false);
const open = ref(false);
const formRef = ref();
const formModel = ref({});

const rules = reactive({
  newPassword: [
    {
      required: true,
      message: "请输入新密码",
      trigger: ["change", "blur"],
    },
    {
      min: 6,
      message: "密码长度至少6位",
      trigger: ["change", "blur"],
    },
    {
      max: 18,
      message: "密码长度最多18位",
      trigger: ["change", "blur"],
    },
    {
      pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[^\w\s]).{6,}$/,
      message:
        "密码强度不足，密码应满足大写字母+小写字母+特殊字符!@#$%^&*()\\-_=+{}[\\]|;:'\",<>.?/",
      trigger: ["change", "blur"],
    },
  ],
  confirmPassword: [
    {
      required: true,
      message: "请输入确认新密码",
      trigger: ["change", "blur"],
    },
    {
      message: "新密码与确认密码不匹配",
      validator: (rule, value) => {
        if (formModel.value.newPassword === value) {
          return Promise.resolve();
        }
        return Promise.reject();
      },
      trigger: ["change", "blur"],
    },
  ],
});

const handleShow = (record) => {
  formModel.value = Object.assign({}, { ...record });
  open.value = true;
};

const handleConfirm = () => {
  formRef.value.validate().then(() => {
    const response = unref(formModel);
    confirmLoading.value = true;
    postRequest("/user/resetPassword", response)
      .then((res) => {
        if (res.success) {
          message.success("密码修改成功");
          handleClose();
        } else {
          message.error(res.message);
        }
      })
      .finally(() => {
        confirmLoading.value = false;
      });
  });
};

const handleClose = () => {
  formModel.value = Object.assign({});
  open.value = false;
};

defineExpose({
  handleShow,
});
</script>

<template>
  <a-modal
    width="600px"
    :open="open"
    :title="title"
    :confirm-loading="confirmLoading"
    @ok="handleConfirm"
    @cancel="handleClose"
  >
    <a-form
      ref="formRef"
      :model="formModel"
      :rules="rules"
      :labelCol="{ span: 4 }"
    >
      <a-form-item label="用户名" name="username">
        <a-input
          v-model:value="formModel.username"
          autocomplete="off"
          :disabled="true"
          placeholder="请输入用户名"
        />
      </a-form-item>
      <a-form-item label="姓名" name="realName">
        <a-input
          v-model:value="formModel.realName"
          placeholder="请输入姓名"
          :disabled="true"
        />
      </a-form-item>
      <a-form-item label="新密码" name="newPassword">
        <a-input-password v-model:value="formModel.newPassword" />
      </a-form-item>
      <a-form-item label="确认新密码" name="confirmPassword">
        <a-input-password v-model:value="formModel.confirmPassword" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<style scoped lang="scss"></style>
